import AdminUserDetails from "./AdminUserDetails";

export default AdminUserDetails;
